/******/ (() => { // webpackBootstrap
    var __webpack_exports__ = {};
    window.PXUTheme.jsVideo = {
        init: function ($section) {
            // Add settings from schema to current object
            window.PXUTheme.jsVideo = $.extend(this, window.PXUTheme.getSectionData($section));

            // Selectors
            const $videoElement = $section.find('[data-video-element]');
            const $playIcon = $section.find('.plyr--paused.plyr--video .plyr__control--overlaid');
            const $playButton = $section.find('[data-play-button]');
            const $videoTextContainer = $section.find('[data-video-text-container]');
            const $imageElement = $section.find('[data-image-element]');

            $imageElement.hide();
            // Load video if the media has been added
            if (this.iframe_video || this.html5_video) {
                // Ensure DOM is fully loaded before initializing Plyr
                if (document.readyState === 'loading') {
                    document.addEventListener('DOMContentLoaded', () => {
                        this.loadVideo($videoElement, $playIcon, $playButton, $videoTextContainer, $imageElement);
                    });
                } else {
                    this.loadVideo($videoElement, $playIcon, $playButton, $videoTextContainer, $imageElement);
                }
            } else {
                $imageElement.show();
            }
        },
        loadVideo: function ($videoElement, $playIcon, $playButton, $videoTextContainer, $imageElement) {
            // Check if it's HTML5 video or iframe
            const isHTML5 = this.html5_video && !this.iframe_video;
            const videoSelector = isHTML5 ? `video.video-${this.id}` : `.video-${this.id}`;

            // Wait for video element to be ready
            const videoElement = document.querySelector(videoSelector);
            if (!videoElement) {
                console.warn('Video element not found');
                return;
            }

            // Set video controls based on settings
            const videoControls = [
                'play-large',
                'play',
                'progress',
                'current-time',
                'mute',
                'volume',
                'fullscreen'
            ];

            // Initialize Plyr with a slight delay to ensure proper setup
            setTimeout(() => {
                const player = new Plyr(videoSelector, {
                    controls: this.controls ? videoControls : false,
                    loop: {
                        active: this.autoloop
                    },
                    fullscreen: {
                        enabled: true,
                        fallback: true,
                        iosNative: true
                    },
                    storage: {
                        enabled: false
                    },
                    hideControls: false,
                    clickToPlay: true,
                    keyboard: { focused: true, global: true },
                    tooltips: { controls: true, seek: true }
                });

                player.muted = this.mute;
                player.ratio = this.aspect_ratio;

                // Make video container visible
                $videoTextContainer.css('display', '');

                // If autoplay enabled, hide image and text
                if (this.autoplay) {
                    player.autoplay = true;
                    $imageElement.hide();
                    $videoTextContainer.hide();
                    $videoElement.show();
                } else {
                    // If autoplay disabled, check if poster image added
                    if (this.poster) {
                        $videoElement.hide();
                        $imageElement.show();
                        $videoTextContainer.show();
                    } else {
                        $imageElement.hide();
                        $videoElement.show();
                        $videoTextContainer.show();
                    }
                }

                // If button exists, clicking button will play video
                if (this.button) {
                    $playButton.on('click', () => {
                        player.play();
                    });
                }

                // Ensure controls are properly shown/hidden based on settings
                if (this.controls) {
                    player.elements.container.classList.remove('plyr--hide-controls');
                } else {
                    player.elements.container.classList.add('plyr--hide-controls');
                }

                // Event listeners
                player.on('ready', () => {
                    if ($playButton && !isScreenSizeLarge() && $videoElement.parents('.mobile-text--below-media').length) {
                        $playIcon.show();
                    } else if ($playButton) {
                        $playIcon.hide();
                    } else {
                        $playIcon.show();
                    }
                });

                player.on('play', () => {
                    $videoElement.show();
                    $imageElement.hide();
                    $videoTextContainer.hide();
                });

                player.on('pause', () => {
                    if (!$playButton) {
                        $playIcon.show();
                    }
                });
            }, 100);
        },
        unload: function ($section) {
            const $playButton = $section.find('[data-play-button]');
            const $videoTextContainer = $section.find('[data-video-text-container]');
            
            // Destroy Plyr instance if it exists
            const videoElement = $section.find('video')[0];
            if (videoElement && videoElement.plyr) {
                videoElement.plyr.destroy();
            }

            $playButton.off();
            $videoTextContainer.off();
        }
    }

    /******/
})()
    ;